import React, { useEffect, useState } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import { Box, Grid2 } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import HeaderNew from "../Layout/Header/Header";
import TerminalHeaderTow from "./TerminalHeaderTow";
import OrderBook from "./OrderBook";
import TradingViewWidget from "./TradingViewWidget";
// import TradeHistory from "./TradeHistory";
import USDT from './USDT.js'
import './Terminal.css';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import ThreeDotsLoader from "../Skeleton/ThreeDotsLoader.js";
import { getAllTradePairList } from "../../Actions/TradePairs/TradePairAction.js";

// tab
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const TradeLayout = () => {
    const theme = useTheme();
    const mobilemd = useMediaQuery(theme.breakpoints.up("md"));
    const mobilemd1 = useMediaQuery(theme.breakpoints.up("1199"));

    // tab2 
    const [tableValue, setValue2] = React.useState(0);
    const handleChange2 = (event, newValue) => {
        setValue2(newValue);
    };

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isAuthenticated } = useSelector((state) => state.auth);
    const { stpLoading, stpData, stpError, stpStatus, selectedPair } = useSelector((state) => state.tradeSTP);
    const { tradePairData, tradePairLoading, tradePairStatus } = useSelector(state => state.tradePair);


    const [searchParams] = useSearchParams();
    const initSymbol = searchParams.get("symbol");

    const [symbolLoading, setSymbolLoading] = useState(false);

    useEffect(() => {
        dispatch(getAllTradePairList({ type: 'all' }));
    }, [dispatch]);

    useEffect(() => {
        if (!tradePairLoading && tradePairData?.length) {
            // normalize list
            const list = tradePairData.filter(item => item.type === "crypto")
            // symbol URL-la irukka?
            const symbolExists = initSymbol ? list?.some(item => item?.symbol === initSymbol) : false;

            //  symbol illa OR list-la match aagala
            if (!initSymbol || !symbolExists) {
                const firstSymbol = list?.[0]?.symbol;
                navigate(`/trade?symbol=${firstSymbol}`, { replace: true });
                setSymbolLoading(false)
            } else {
                setSymbolLoading(false)
            }
        }
    }, [tradePairLoading, tradePairData, initSymbol]);

    return (
        <div className="FuturesTradeGridLayout-main-pages">
            <Box sx={{ background: "var(--color-SecondaryBg)" }}>
                <Grid2 container spacing={0.5}>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <HeaderNew />
                    </Grid2>
                    {symbolLoading === true ? (
                        <ThreeDotsLoader />
                    ) : (

                        <>
                            <Grid2
                                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                                sx={{ paddingTop: { xs: "40px", md: "60px" } }}
                            >
                                <Grid2 container spacing={0.5} sx={{ padding: "10px 15px" }}>
                                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                        <div>
                                            <TerminalHeaderTow />
                                        </div>
                                    </Grid2>
                                    <Grid2
                                        size={{ xs: 12, sm: 12, md: 7, lg: 6, xl: 7 }}
                                        sx={{
                                            height: { xs: "100%", sm: "100%", md: "600px" },
                                            overflow: "hidden",
                                        }}
                                    >
                                        {!mobilemd && (
                                            <div>
                                                {/* {location?.state?.tabValue != "all-history" && ( */}
                                                <Box className="display-2 ads-tab tab-cmn History-tab mt-10 mb-10">
                                                    <Tabs value={tableValue} onChange={handleChange2} variant="scrollable"
                                                        className="no-drag"
                                                        scrollButtons
                                                        allowScrollButtonsMobile
                                                        aria-label="scrollable force tabs example" sx={{ minHeight: '30px' }}>
                                                        <Tab sx={{ fontSize: '12px' }} label="Chart" {...a11yProps(0)} />
                                                        <Tab sx={{ fontSize: '12px' }} label="Order Book" {...a11yProps(1)} />
                                                        <Tab sx={{ fontSize: '12px' }} label="Trade" {...a11yProps(2)} />
                                                        {/* <Tab sx={{ fontSize: '12px' }} label="Trade History" {...a11yProps(3)} /> */}
                                                    </Tabs>
                                                </Box>
                                                {/* )} */}

                                                <CustomTabPanel
                                                    value={tableValue}
                                                    index={0}
                                                    className="futures-trade-table"
                                                >
                                                    <Box
                                                        sx={{
                                                            height: 'calc(100vh - 270px)',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                        }}
                                                    >
                                                        <TradingViewWidget />
                                                    </Box>
                                                </CustomTabPanel>

                                                <CustomTabPanel
                                                    value={tableValue}
                                                    index={1}
                                                    className="futures-trade-table"
                                                >
                                                    <div className="mobile-orderbook">
                                                        <Grid2
                                                            container
                                                            spacing={0.5}
                                                            sx={{
                                                                paddingBottom: { xs: "65px", md: "aouto" },
                                                            }}
                                                        >
                                                            <Grid2
                                                                item
                                                                size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                                                            >
                                                                {/* <OrderBook /> */}
                                                            </Grid2>
                                
                                                        </Grid2>
                                                    </div>
                                                </CustomTabPanel>

                                                <CustomTabPanel
                                                    value={tableValue}
                                                    index={2}
                                                    className="futures-trade-table"
                                                >
                                                    {/* <MarketTrade /> */}

                                                    <USDT />
                                                </CustomTabPanel>

                                            </div>
                                        )}

                                        <div
                                            className="h-full"
                                            style={{ display: mobilemd ? "block" : "none" }}
                                        >
                                            {/* <FutureTradingViewWidget  /> */}
                                            <TradingViewWidget />
                                        </div>
                                    </Grid2>

                                    <Grid2
                                        size={{ xs: 12, sm: 12, md: 2.5, lg: 3, xl: 2.5 }}
                                        sx={{
                                            height: { xs: "auto", sm: "auto", md: "600px" },
                                            overflow: "hidden",
                                            display: mobilemd ? "block" : "none",
                                        }}
                                    >
                                        <div>
                                            <OrderBook />
                                        </div>
                                    </Grid2>

                                    <Grid2
                                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 2.5 }}
                                        sx={{
                                            display: mobilemd1 ? "block" : "none",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <div className="">
                                            <USDT />
                                        </div>
                                    </Grid2>

                                    {/* <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ display: mobilemd ? "block" : "none" }} >
                                        <div className="mt-5">
                                            <TradeHistory />
                                        </div>
                                    </Grid2> */}
                                </Grid2>
                            </Grid2>

                        </>
                    )}
                </Grid2>

            </Box>
        </div>
    );
};

export default TradeLayout;